
                import Handlebars from 'handlebars/dist/handlebars.runtime';
                const templateFunction = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"not-found\" >\n    <h2 class=\"not-found_title\">\n        Sorry, no events found\n    </h2>\n    <button class=\"not-found_button\" type=\"button\" id=\"back-to-main\">Back to main</button>\n</div>";
},"useData":true});
                export default templateFunction;
                